module.exports = __webpack_public_path__ + "img/zohdk.f7dc13ae.png";